// LiveStreamGoalItem.jsx
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';

import Marquee from '../component/Marquee.jsx';
import useKaraokeTranslation from '../hook/useKaraokeTranslation.js';
import { TranslationNamespace } from '../resource/translationNamespace.js';

export const LiveStreamGoalItem = ({
  started = false,
  senderId = null,
  senderUsername = null,
  fetchUser = () => null,
  goalTitle = '',
  target = 0,
  t,
  productId = '',
  hasToyDevice = false,
}) => {
  useEffect(() => {
    if (senderId && !senderUsername) {
      fetchUser({ userId: senderId });
    }
  }, [senderId, senderUsername, fetchUser]);

  const displayTitle = useKaraokeTranslation({
    productId,
    hasToyDevice,
    title: goalTitle,
  });
  return (
    <StyledLiveStreamGoalItem isActive={started}>
      {started ? (
        <Text>
          <Marquee
            text={t('performing_announcement', {
              username: senderUsername,
              command: displayTitle,
              duration: target,
              ns: TranslationNamespace.LIVESTREAM,
            })}
            duration={12}
            justify={'center'}
          />
        </Text>
      ) : (
        <Text>{`${displayTitle} ${t('command_sec', {
          number: target,
          ns: TranslationNamespace.LIVESTREAM,
        })}`}</Text>
      )}
    </StyledLiveStreamGoalItem>
  );
};

LiveStreamGoalItem.propTypes = {
  t: PropTypes.func.isRequired,
  started: PropTypes.bool,
  senderId: PropTypes.string,
  senderUsername: PropTypes.string,
  productId: PropTypes.string,
  goalTitle: PropTypes.string,
  target: PropTypes.number,
  hasToyDevice: PropTypes.bool,
  fetchUser: PropTypes.func,
};

const StyledLiveStreamGoalItem = styled.div`
  width: 100%;
  height: 20px;
  padding: 4px 8px;
  font-size: 12px;
  line-height: 12px;
  font-weight: ${({ isActive }) => (isActive ? 600 : 'normal')};
  color: ${({ isActive }) => (isActive ? '#ffffff' : '#646464')};
`;

const Text = styled.div`
  text-align: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export default withTranslation()(LiveStreamGoalItem);
